import { Component, OnInit } from '@angular/core';
import { HomeService } from '../services/home/home.service';
import { CartService } from "../services/cart/cart.service";
import { Injectable } from '@angular/core';
import { Product } from '../model/product';
import { ItemCart } from '../model/itemCart';
import { UserService } from '../services/user/user.service';
import { CategoryService } from '../services/category/category.service';
import { ProductService } from "../services/product/product.service";
import { environment } from "../../environments/environment";
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  lastProducts:Product[];
  listFournisseur:Product[];
  listCart:ItemCart[];
  contentLoaded = false;
  baseUrl = environment.baseUrl
  constructor(private homeService:HomeService,private cartService:CartService,
    private userService:UserService,private categoryService:CategoryService,private productService:ProductService ) {
  }

  ngOnInit(): void {
      this.productService.productByCategory("11",1).subscribe(res => {
         this.contentLoaded = true;
         this.lastProducts = res['produits'];
       });
      this.productService.getProductByMarque(104).subscribe(res => {
        this.listFournisseur = res['products'];
      });
      
  }






}
